import React from 'react';
import { Row, Col, Alert, Button, ButtonToolbar } from 'react-bootstrap';
import FieldGroup from './common/FieldGroup.jsx';

export default class BagLabelComponent extends React.Component {

  componentDidMount() {
  }

  componentWillUnmount() {
    this.props.cleanAlert();
  }

  render() {

    let downloadLinkStyle = {
      display: this.props.bagLabel.get('outputFile') === '' ? 'none' : 'block'
    };

    let openPdf = () => {
      window.open(this.props.bagLabel.get('outputFile'));
    };

    let downloadLinkStyle2 = {
      display: this.props.bagLabel.get('outputFile2') === '' ? 'none' : 'block'
    };

    let openPdf2 = () => {
      window.open(this.props.bagLabel.get('outputFile2'));
    };

    let alertDiv = null;
    if (this.props.alertStyle || this.props.alertMessage) {
      alertDiv = (
        <Alert bsStyle={this.props.alertStyle} onDismiss={this.props.cleanAlert}>
          {this.props.alertMessage}
        </Alert>
      );
    }

    return (
      <div>
        <Row style={{ marginTop: 10, marginLeft: -15, marginRight: -15 }}>
          <Col xs={12} sm={12} md={12}>
            {alertDiv}
          </Col>
        </Row>
        <h4>成套標籤</h4>
        <Row>
          <Col xs={3} sm={3} md={3}>
            <FieldGroup
              id="ordererIdFrom"
              type="number"
              label="人員編號 From"
              value={this.props.bagLabel.get('ordererIdFrom')}
              placeholder=""
              onChange={(id, value) => {
                this.props.setValue(id, value);
              }}
              validation={this.props.bagLabelValidation.get('ordererIdFrom')}
            />
          </Col>
          <Col xs={3} sm={3} md={3}>
            <FieldGroup
              id="ordererIdTo"
              type="number"
              label="人員編號 To"
              value={this.props.bagLabel.get('ordererIdTo')}
              placeholder=""
              onChange={(id, value) => {
                this.props.setValue(id, value);
              }}
              validation={this.props.bagLabelValidation.get('ordererIdTo')}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={6} md={6}>
            <ButtonToolbar>
              <Button bsStyle="info" onClick={this.props.generateBagLabel}>產生PDF檔</Button>
              <Button style={downloadLinkStyle} bsStyle="default" onClick={openPdf}>開啟PDF檔</Button>
            </ButtonToolbar>
          </Col>
        </Row>
        <hr />
        <h4>不成套標籤(備品)</h4>
        <Row>
          <Col xs={12} sm={6} md={6}>
            <ButtonToolbar>
              <Button bsStyle="info" onClick={this.props.generateBagLabel2}>產生PDF檔</Button>
              <Button style={downloadLinkStyle2} bsStyle="default" onClick={openPdf2}>開啟PDF檔</Button>
            </ButtonToolbar>
          </Col>
        </Row>
      </div>
    )
  }
};


// WEBPACK FOOTER //
// ./src/components/BagLabelComponent.jsx